import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const httpInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((err: any) => {
      let errorMessage = 'Error! Please try again.';

      if (err instanceof Response) {
        console.error(errorMessage);
      } else if (err.error?.message) {
        console.error(err.error.message);
      } else if (err.message) {
        console.error(err.message);
      }

      snackBar.open(errorMessage, '', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['red-snackbar']
      });

      return throwError(() => err);
    })
  );
};
